import React from 'react';
import { Col } from 'react-bootstrap';
import ImmutableUnderReviewFormControl from '../reviewEditControls/ImmutableUnderReviewFormControl';
import { DatePicker, MonthPicker, datesInChronologicalOrder, getLocaleDateFormat } from '.';

/**
 * @param {string} datePickerType - one of month | date
 */
const ProjectReportDateColumns = _ref => {
  let {
    disabled,
    report,
    handleProjectReportChange,
    index,
    datePickerType = "month",
    handleToaster
  } = _ref;
  const DatePickerComponent = datePickerType === "month" ? MonthPicker : DatePicker;
  const checkAndHandleDates = (name, date) => {
    handleProjectReportChange({
      target: {
        value: date,
        name: name
      }
    }, index);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: DatePickerComponent,
    disabled: disabled,
    selected: report.start_date,
    onChange: date => checkAndHandleDates('start_date', date)
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: DatePickerComponent,
    disabled: disabled,
    selected: report.end_date,
    onChange: date => checkAndHandleDates('end_date', date)
  }))));
};
export default ProjectReportDateColumns;